class EsimPlanPicker extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);

    const activeTab = this.querySelector('[data-plan-tab][aria-selected="true"]') || this.querySelector('[data-plan-tab]');
    if (activeTab instanceof HTMLButtonElement) this.activate(activeTab.dataset.planTab, false);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  handleClick(event) {
    const tab = event.target.closest('[data-plan-tab]');
    if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;
    this.activate(tab.dataset.planTab, false);
  }

  handleKeydown(event) {
    const currentTab = event.target.closest('[data-plan-tab]');
    if (!(currentTab instanceof HTMLButtonElement) || !this.contains(currentTab)) return;

    const tabs = Array.from(this.querySelectorAll('[data-plan-tab]'));
    const currentIndex = tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    const nextTab = tabs[nextIndex];
    this.activate(nextTab.dataset.planTab, true);
  }

  activate(planType, focusTab) {
    if (!planType) return;

    for (const tab of this.querySelectorAll('[data-plan-tab]')) {
      const isActive = tab.dataset.planTab === planType;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive && focusTab) tab.focus();
    }

    for (const panel of this.querySelectorAll('[data-plan-panel]')) {
      panel.hidden = panel.dataset.planPanel !== planType;
    }
  }
}

if (!customElements.get('esim-plan-picker')) {
  customElements.define('esim-plan-picker', EsimPlanPicker);
}

